import { useState, useEffect } from "react";
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone } from '@fortawesome/fontawesome-svg-core/import.macro';
import IncomingGroupCalls from './incominggroupcalls';
import OutgoingGroupCalls from './outgoinggroupcalls';
import { SelectBox } from 'devextreme-react';
import useMonitorAPIService from 'src/services/monitorapiservice';
import AgentCard from "../widgets/agentspanel/agentcard";
import { abbreviate } from "../utils/utils";

function GroupStats(props) {

    const { t } = useTranslation();
    const [agents, setAgents] = useState([]);
    const { getGroupAgents } = useMonitorAPIService();
    const priorities = [{ value: -1, text: t('disabled') },
    { value: 1, text: t('minimum') },
    { value: 10, text: t('verylow') },
    { value: 20, text: t('low') },
    { value: 30, text: t('normal') },
    { value: 40, text: t('high') },
    { value: 50, text: t('veryhigh') },
    { value: 60, text: t('maximum') }];

    const states = [
        { value: true, text: t('open') },
        { value: false, text: t('closed') },
        { value: null, text: t('schedule') }
    ];

    useEffect(() => {

        getAgents();
        var interval = setInterval(() => {
            getAgents();
        }, (5000));
        return () => {
            // component unmounts
            clearInterval(interval);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.group.groupId]);

    const handlePriorityChange = (priority) => {
        props.updateGroupPriority(props.group, priority);

    };

    const handleStateChange = (value) => {
        props.updateGroupState(props.group, value);
    };

    const getAgents = () => {
        getGroupAgents(props.token, props.group.groupId, (res) => {
            if (res.data != null && res.data.length > 0) {
                setAgents(res.data);
            } else {
                setAgents([]);
            }
        });

    }
    return (<>
        <Row>
            <Col>
                <div className={"d-flex align-items-center me-2 p-10"}>
                    <div className="symbol symbol-75px me-3">
                        <div className='user-img text-primary bg-light-primary'>{props.group.initials}</div>
                        <div className={"position-absolute translate-middle bottom-0 start-100 mb-6 rounded-circle border border-4 border-body h-20px w-20px bg-" + (props.group.opened ? "success" : "danger")}></div>
                    </div>
                    <div className="w-100">
                        <div className="fs-1 text-primary fw-bold w-100">{props.group.groupName} </div>
                        <div className="fs-4 text-muted fw-bold">{props.group.campaign || "-"}</div>

                    </div>
                </div>
            </Col>
        </Row>
        <Row>
            <Col>
                <div className={"card card-flush overflow-hidden"} >
                    <div className="card-header ">
                        <h3 className="card-title align-items-start flex-column text-primary">
                            <span className="card-label fw-bold text-primary"><FontAwesomeIcon icon={duotone("cogs")} /> {t("config")}</span>
                        </h3>
                        <div className="card-toolbar">
                        </div>
                    </div>
                    <div className="card-body" style={{ "padding": "0rem 2.25rem" }}>
                        <Row>
                            <Col>
                                <span class="fs-4 fw-bold text-primary my-2">{t("status")}</span>
                            </Col>
                            <Col>
                                <SelectBox className='m-1'
                                    dataSource={states}
                                    disabled={!props?.functions?.changeGroupStatus}
                                    value={props.group.opened}
                                    onValueChange={handleStateChange}
                                    valueExpr="value"
                                    displayExpr="text"
                                    dropDownButtonRender={() => { return (<FontAwesomeIcon icon={duotone("down")} />) }}
                                />
                            </Col>

                            <Col>
                                <span class="fs-4 fw-bold text-primary my-2">{t("priority")}</span>
                            </Col>
                            <Col>
                                <SelectBox className='m-1'
                                    dataSource={priorities}
                                    value={props.group.priority}
                                    disabled={!props?.functions?.changeGroupPriority}
                                    onValueChange={handlePriorityChange}
                                    valueExpr="value"
                                    displayExpr="text"
                                    dropDownButtonRender={() => { return (<FontAwesomeIcon icon={duotone("down")} />) }}
                                />
                            </Col>
                        </Row>

                    </div>
                </div>
            </Col>
        </Row >
        <Row>
            <Col>
                <IncomingGroupCalls group={props.group}></IncomingGroupCalls>
            </Col>

        </Row>
        <Row>
            <Col>
                <OutgoingGroupCalls group={props.group}></OutgoingGroupCalls>
            </Col>
        </Row>
        <Row>
            <Col>
                <div className={"card card-flush overflow-hidden"} >
                    <div className="card-header ">
                        <h3 className="card-title align-items-start flex-column text-primary">
                            <span className="card-label fw-bold text-primary"><FontAwesomeIcon icon={duotone("address-card")} /> {t("agents")}</span>
                        </h3>
                        <div className="card-toolbar">
                        </div>
                    </div>
                    <div className="card-body" style={{ "padding": "0rem 2.25rem" }}>
                        <Row>
                            {
                                agents.map(v => {
                                    v.initials = abbreviate(v.name);
                                    return <AgentCard key={v.pin} agent={v} hideOptions={true}></AgentCard>
                                })
                            }
                        </Row>
                    </div>
                </div>
            </Col>
        </Row>
    </>
    );
}

const mapStateToProps = (state) => {
    return {
        token: state.supervisor.token,
        functions: state.supervisor.functions
    };
};

export default connect(mapStateToProps, {})(GroupStats);